/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class VisitorProfileFieldsApiService {
  constructor(
    private readonly client: AdnApiClientService,
    private readonly localNetworkProfile: LocalNetworkProfile,
    private readonly apiConfig: ApiConfig
  ) {
  }

  get(): Observable<any[]> {
    return this.client.request<{results: any[]}>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('visitorprofilefields'),
      params: {context: this.localNetworkProfile.getNetworkId()}
    }).pipe(map((page) => page.results || []));
  }
}
